import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
	'use strict';

	angular
        .module('riskSelfAssessmentListControllers')
        .factory('riskSelfAssessmentListService', service);

	service.$inject = ['$http', '$q', 'env'];

	function service($http, $q, env) {
	    var baseUrl = environment.apiUrl + '/Pilot/api/RiskSelfAssessment';
		var baseReportUrl = environment.apiUrl + '/ReportPilot/api/RiskSelfAssessment';

	    var service = {
	        resetAllAnswers:      resetAllAnswers,
	        sendEmailToAssessor : sendEmailToAssessor,
	        summaryExportToExcel: summaryExportToExcel,
	        summaryExportToReport: summaryExportToReport
		};
		return service;

		////////////

	    // Reset All Answers
		function resetAllAnswers(assessorId) {
		    var reqUrl = baseUrl + '/Assessor@' + assessorId + '/Reset';

		    return $http.post(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Send Email To Assessor
		function sendEmailToAssessor(assessor, deadline) {
		    var reqUrl = baseUrl + '/SendEmailToAssessor';

		    var isDebug = env.isDev || undefined;

		    return $http.post(reqUrl, {
		        Assessor: assessor,
		        DeadLine: deadline,
		        isDebug: isDebug
		    })
            .then(function (response) {
                return response.data;
            });
		}

	    // SummaryExportToExcel
		function summaryExportToExcel(assessorId) {
		    var reqUrl = baseReportUrl + '/Assessor@' + assessorId + '/SummaryExportToExcel';

		    return $http.post(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // SummaryExportToReport
		function summaryExportToReport(assessorId) {
		    var reqUrl = baseReportUrl + '/Assessor@' + assessorId + '/SummaryExportToReport';

		    return $http.post(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}
	}
})();
